import { controls,grouped } from "../controls";
const reconcile_cf_wrong_paids = {
label: "Reconcile Cf Wrong Paids",
pageLabel: "Reconcile Cf Wrong Paids",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.magicDateLabel({ tab: "filter", label: "As On Date",target: "as_on_date"}),
...controls.magicDate({ tab: "filter", name: "as_on_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Branch"}),
...controls.oc({ tab: "filter",length:4, c: "Branch", placeHolder: "Branch Code", name: "ReconcileCFWrongPaid-branch-branch_code",fastpath: "branches"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "ReconcileCFWrongPaid-branch-branch_display"}),
]
,form:[
...controls.magicDateLabel({ tab: "general", label: "As On Date",target: "as_on_date",star:true}),
...controls.magicDate({ tab: "general", name: "as_on_date", dateType: "ontype",isRequired:true ,isReadOnly:"edit" ,default:"n" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Bank",star:false}),
...controls.oc({ tab: "general", c: "Bank", placeHolder: "Bank Code", name: "bank_code",fastpath: "banks" ,isReadOnly:"edit" ,clearData: ['branch_code'],hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "bank_display"}),
...controls.displayText({ tab: "general", label: "Branch",star:false}),
...controls.oc({ tab: "general", length:4, c: "Branch", placeHolder: "Branch Code", name: "branch_code",fastpath: "branches" ,isReadOnly:"edit" ,sendToServer: { sendData: [{ varname: 'bank.bank_uid', value: 'bank_uid' }] } ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display"}),
]
,history:{
perPage: 10,
reportHeader: "Reconcile Cf Wrong Paids",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "As On Date",accessor: "as_on_date",type:'date'},
{Header: "Branch Code",accessor: "ReconcileCFWrongPaid-branch-branch_code",},
{Header: "Branch",accessor: "ReconcileCFWrongPaid-branch-branch_display",},
{Header: "Updated Count",accessor: "updated_count",},
{Header: "Updated Amount",accessor: "updated_amount",},
]}};
export default reconcile_cf_wrong_paids;